var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat408(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_408"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_408",
    "data-name": 408,
    className: "cls-2",
    d: "M80.49,40.06c4.7,10.31,8.52,22.2,7.3,33.65C86.46,86.22,76,98.53,62.65,98.06,43.05,97.38,34,74.44,30.07,58.25c-3.35-13.94-9-49.48,8.87-55.73C52.29-2.16,72.14,21.74,80.49,40.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat408);
export default __webpack_public_path__ + "static/media/cat_408.a8b5bb83ba5ead08399c9a5ae8915706.svg";
export { ForwardRef as ReactComponent };